export const VALIDATION = {
  TYPE: ['Неверный тип данных'],
  PHONE: [{
    test: value => /^[-+()0-9 ]+$/.test(value),
    message: 'Разрешены символы ()+-0123456789',
  }],
  TRIM: ['Не должно быть пробелов по краям строки'],
  REQUIRED: ['Это поле обязательно для заполнения'],
  EMAIL: ['Введите корректный email'],
  SPACES_NOT_RESOLVED: [{
    test: value => !/\s/g.test(value),
    message: 'Пробелы не разрешены',
  }],
  NUMBER: ['Введите число'],
  PRODUCT: ['Выберите продукт'],
  SHIPPED_TON_EXCEEDS_TON: ['Значение "Отгружено" не может превышать значение "Количество, тонн".'],
  MAX_STRING: ({ max }) => `Максимальная длина строки ${max} символов`,
  MIN_STRING: ({ min }) => `Минимальная длина строки ${min} символов`,
  MAX_NUMBER: ({ max }) => `Максимальное число ${max}`,
  MIN_NUMBER: ({ min }) => `Минимальное число ${min}`,
  MIN: (min, msg = 'Ошибка валидации') => [min, msg],
  MAX: (max, msg = 'Ошибка валидации') => [max, msg],
  ONEOF: (values = [], msg = `Должно быть одним из следующих значений: ${values.join(', ')}`) => [values, msg],
};

export const ROLE = {
  USER: 0,
  ADMIN: 1,
  MANAGER: 2,

  0: 'USER',
  1: 'ADMIN',
  2: 'MANAGER',

  isRole(role, roles = []) {
    return roles.length && roles.some(value => this[this[value]] === Number(role));
  },

  toString(value) {
    switch (value) {
      case this.USER:
        return 'Пользователь';
      case this.ADMIN:
        return 'Админ';
      case this.MANAGER:
        return 'Менеджер';
      default:
        return '';
    }
  },

  list() {
    return [
      this.USER,
      this.ADMIN,
      this.MANAGER,
    ];
  },
};

export const CONTRACT_STATUS = {
  draw: 0,
  performing: 1,
  suspended: 2,
  terminated: 3,

  toString(value) {
    switch (value) {
      case this.performing:
        return 'исполняемый';
      case this.draw:
        return 'оформляемый';
      case this.suspended:
        return 'приостановленный';
      case this.terminated:
        return 'расторгнутый';
      default:
        return '';
    }
  },

  list() {
    return [
      this.draw,
      this.performing,
      this.suspended,
      this.terminated,
    ];
  },
};

export const STATUS_APPLICATION_WAGON = {
  COMPLETE: 0,
  WORK: 1,
  CANCEL: 2,
  AGREED: 3,

  toString(value) {
    switch (value) {
      case this.AGREED:
        return 'Согласовано';
      case this.WORK:
        return 'В работе';
      case this.COMPLETE:
        return 'Выполнена';
      case this.CANCEL:
        return 'Отменена';
      default:
        return '';
    }
  },

  list() {
    return [
      this.COMPLETE,
      this.WORK,
      this.CANCEL,
      this.AGREED,
    ];
  },
};

export const STATUS_APPLICATION_SUPPLY = {
  QUEUE: 0,
  CHECK: 1,
  COMPLETE: 2,
  CANCEL: 3,
  WAIT: 4,
  SHIPPED: 5,
  DELIVERED: 6,

  toString(value) {
    switch (value) {
      case this.QUEUE:
        return 'В очереди';
      case this.CHECK:
        return 'В обработке';
      case this.COMPLETE:
        return 'Заявка закрыта';
      case this.CANCEL:
        return 'Отказ';
      case this.WAIT:
        return 'Ожидание';
      case this.SHIPPED:
        return 'Отгружен';
      case this.DELIVERED:
        return 'Доставлен';
      default:
        return '';
    }
  },

  list() {
    return [
      this.QUEUE,
      this.CHECK,
      this.COMPLETE,
      this.CANCEL,
      this.WAIT,
      this.SHIPPED,
      this.DELIVERED,
    ];
  },
};

export const CONSIGNEE_APPLICATION_STATUS = {
  PROCESSING: 0,
  PROCESSED: 1,

  toString(value) {
    switch (value) {
      case this.PROCESSING:
        return 'В обработке';
      case this.PROCESSED:
        return 'Обработан';
      default:
        return '';
    }
  },
};

export const MAILING_STATUS = {
  CANCEL: 0,
  APPROVE: 1,

  toString(value) {
    switch (value) {
      case this.CANCEL:
        return 'нет';
      case this.APPROVE:
        return 'да';
      default:
        return '';
    }
  },
};

export const MONTHLY_FUND_STATUS = {
  SUMMA: 0, // сумма фондов начиная с текщего месяца
  MONTH: 1, // фонд за месяц

  toString(value) {
    switch (value) {
      case this.SUMMA:
        return 'нет';
      case this.MONTH:
        return 'да';
      default:
        return '';
    }
  },
};

export const EVENT_TYPE = {
  USER_AUTH: 0,
  APPLICATION_CREATE: 1,
  APPLICATION_CHANGE_STATUS: 2,
  QUEUE_CHANGE: 3,
  COMPANY_DATA_UPDATE: 4,
  UPDATE_TON: 5,
  APPLICATION_CHANGE_GY12: 6,

  toString(value) {
    switch (value) {
      case this.USER_AUTH:
        return 'Авторизация пользователя';
      case this.APPLICATION_CREATE:
        return 'Создание заявки';
      case this.APPLICATION_CHANGE_STATUS:
        return 'Изменение статуса заявки';
      case this.QUEUE_CHANGE:
        return 'Изменение очереди';
      case this.COMPANY_DATA_UPDATE:
        return 'Обновление данных компании';
      case this.UPDATE_TON:
        return 'Изменение количества тонн';
      case this.APPLICATION_CHANGE_GY12:
        return 'Изменение номера ГУ-12';
      default:
        return '';
    }
  },
};

export const WAGON_UTENSILS = {
  BZD: 0,
  OWN: 1,
  RENTED: 2,

  toString(value) {
    switch (value) {
      case this.BZD:
        return 'Инвентарный парк БЖД';
      case this.OWN:
        return 'Собственные';
      case this.RENTED:
        return 'Арендованные';
      default:
        return '';
    }
  },

  list() {
    return [
      this.BZD,
      this.OWN,
      this.RENTED,
    ];
  },
};

export const APPLICATION_TYPE = {
  MAIN: 0,
  ADDITIONAL: 1,

  toString(value) {
    switch (value) {
      case this.MAIN:
        return 'Основная (ОГУ-12)';
      case this.ADDITIONAL:
        return 'Дополнительная (ДГУ-12)';
      default:
        return '';
    }
  },

  list() {
    return [
      this.MAIN,
      this.ADDITIONAL,
    ];
  },
};

export const PRODUCT_GROUP = {
  ONE: 0,
  TWO: 1,

  toString(value) {
    switch (value) {
      case this.ONE:
        return 'ЩЕБЕНЬ';
      case this.TWO:
        return 'ОТСЕВ';
      default:
        return '';
    }
  },

  list() {
    return [
      this.ONE,
      this.TWO,
    ];
  },
};
